


















import { Component, Mixins } from "vue-property-decorator";
import { VectorDragHandles } from "../../../../../../base/components/dragging";
import { LineDrawer } from "../../../../../../base/components/drawing/drawers";
import { LineObjectDrawerBase } from "./base";

@Component({
  components: {
    LineDrawer,
    VectorDragHandles,
  },
})
export default class LineObjectDrawer extends Mixins(LineObjectDrawerBase) {}
